import { jwtDecode } from "jwt-decode";
import { api } from "../services/api";

let toastFn = null;
let sessionExpiredHandler = null;
let refreshRequestInFlight = false;

const REFRESH_WINDOW_MS = 2 * 60 * 1000;

let lastRefreshTime = 0;
const REFRESH_COOLDOWN_MS = 60 * 1000; // 1 minute
const AUTH_REDIRECT_IN_PROGRESS_KEY = "authRedirectInProgress";
const AUTH_ROUTES = new Set([
  "/",
  "/login",
  "/auth-redirect",
  "/auth/callback",
  "/validuser",
]);

const clearRefreshAuthState = () => {
  sessionStorage.removeItem('accessToken')
  sessionStorage.removeItem("tokenExpireTime");
  sessionStorage.removeItem("sessionStartTime");
  sessionStorage.removeItem("userDtls");
};

export const registerToast = (fn) => {
  toastFn = fn;
};

export const registerSessionExpiredHandler = (fn) => {
  sessionExpiredHandler = fn;
};

export const markAuthRedirectInProgress = () => {
  sessionStorage.setItem(AUTH_REDIRECT_IN_PROGRESS_KEY, "true");
};

export const clearAuthRedirectInProgress = () => {
  sessionStorage.removeItem(AUTH_REDIRECT_IN_PROGRESS_KEY);
};

export const isAuthRoute = (pathname = globalThis.location?.pathname || "/") =>
  AUTH_ROUTES.has(pathname);

export const shouldSuppressSessionExpiredFeedback = (
  pathname = globalThis.location?.pathname || "/"
) =>
  isAuthRoute(pathname) ||
  sessionStorage.getItem(AUTH_REDIRECT_IN_PROGRESS_KEY) === "true";

export const showToast = (message, variant = "danger") => {
  if (toastFn) {
    toastFn(message, variant);
  }
};

export const showSessionExpiredPopup = (message) => {
  if (shouldSuppressSessionExpiredFeedback()) {
    return;
  }

  if (sessionExpiredHandler) {
    sessionExpiredHandler(message);
  }
};

export const evaluateAndReturn = (
  condition,
  successReturn,
  failReturn
) => {
  if (condition) {
    return successReturn;
  }
  return failReturn;
};

// utils/checkAccess.js

export const checkAccess = (userRoles, pageLabel) => {
  // If user is a Client
  // if (userRoles === "Client") {
  //   return (
  //     pageLabel !== "organization" &&
  //     pageLabel !== "settings" &&
  //     pageLabel !== "audit" &&
  //     pageLabel !== "application_template" &&
  //     pageLabel !== "users" &&
  //     pageLabel !== "roles_management"
  //   );
  // }

  

  // If user is SRE or FinopsSupport
  if (userRoles === "SRE" || userRoles === "FinopsSupport") {
    return (
      pageLabel !== "Resources" &&
      pageLabel !== "organization" &&
      pageLabel !== "audit" &&
      pageLabel !== "users" &&
      pageLabel !== "provider"
    );
  }

  return true;
};

export const checkTokenExpiration = (
  token,
  tokenExpireTime,
  sessionStartTime,
  history,
  { setToken }
) => {
  if (!token || !tokenExpireTime || !sessionStartTime) {
    return;
  }

  const currentTimestamp = Date.now();
  const timeLeft = Number(tokenExpireTime) - currentTimestamp;

  if (
    timeLeft <= REFRESH_WINDOW_MS &&
    currentTimestamp - lastRefreshTime > REFRESH_COOLDOWN_MS
  ) {

    lastRefreshTime = currentTimestamp;
    fetchRedirectData(history, { setToken });
  }
};

export const fetchRedirectData = async (history, { setToken }) => {
  if (refreshRequestInFlight) {
    return;
  }

  refreshRequestInFlight = true;

  try {
    const response = await api.post(
      "Account/RefreshToken",
      {},
      {
        withCredentials: true,
        skipAuthHeader: true,
        skipAutoSafeToast: true,
      }
    );

    const jwt = response.data;

    if (jwt) {
      sessionStorage.setItem("accessToken", jwt);

      const decoded = jwtDecode(jwt);

      const expirationDate = new Date(decoded.exp * 1000);
      const expirationTimestamp = expirationDate.getTime();
      const currentTimestamp = Date.now();

      sessionStorage.setItem(
        "tokenExpireTime",
        expirationTimestamp.toString()
      );
      sessionStorage.setItem(
        "sessionStartTime",
        currentTimestamp.toString()
      );
      sessionStorage.setItem("userDtls", decoded.email);

      return;
    }

    clearRefreshAuthState();
    showSessionExpiredPopup(
      "Your session has expired. Please login again."
    );
    return;
  } catch (err) {
    clearRefreshAuthState();

    if (err.response?.status === 401) {
  const { code, message } = err.response.data || {};

  if (code === "SESSION_EXPIRED") {
    showSessionExpiredPopup(
      message || "Your session has expired. Please login again."
    );
    return;
  }
}

    history("/login");
  } finally {
    refreshRequestInFlight = false;
  }
};
